const $ = window.jQuery;
const jQuery = window.jQuery;

if ($('[data-video-timeline]').length) {
	var track_text = $('[data-video-timeline]');
	var track_text_markers = $('[data-video-timeline-marker]');
	var player = new Vidyard.player(track_text.attr('data-video-timeline'));

	var time = -1,
	timeline = [];

	track_text_markers.each(function() {
		timeline[parseInt($(this).attr('data-video-timeline-marker'))] = $(this).text();
	});

	setInterval(function() {
		time = Math.floor(player.currentTime());
		var closest = closestInTimeline(timeline, time);

		if (time != closest) {
			time = closest;
			track_text_markers.removeClass('active');
			$('[data-video-timeline-marker=' + time + ']').addClass('active');
		}
	}, 100);
}

function closestInTimeline(list, x) {
	var closest = list[0];
	for (var i in list) {
		if (list[i] && i <= x) {
			closest = i;
		}
	}
	return closest;
}